import {useRef, useEffect, useState} from "react";
import Header from "./components/Layout/Header/Header";
import BackToTopButton from "./components/Layout/BackToTopButton/BackToTopButton";
import Hero from "./components/Sections/Hero/Hero";
import About from "./components/Sections/About/About";
import ProductsSection from "./components/Sections/Products/ProductsSection";
import Coverage from "./components/Sections/Coverage/Coverage";
import TeamSection from "./components/Sections/Team/TeamSection";
import ConferencesSection from "./components/Sections/Conferences/ConferencesSection";
import {usePreventingScale} from "./assets/additionalFunctions/PreventingScaleByDoubleClick";
import ContactSection from "./components/Sections/Contact/ContactSection";
import Footer from "./components/Layout/Footer/Footer";


function App() {
  usePreventingScale();

  const [activeSection, setActiveSection] = useState("home");
  const sections = {
    home: useRef(null),
    about: useRef(null),
    products: useRef(null),
    coverage: useRef(null),
    team: useRef(null),
    conferences: useRef(null),
    contact: useRef(null),
  };


  const SCROLL_OFFSET_EXTRA = 12;

  const scrollTo = (key) => {
    const el = sections[key].current;
    if (!el) return;

    const headerHeight = document.querySelector(".header")?.offsetHeight ?? 0;
    const top = el.getBoundingClientRect().top + window.scrollY - headerHeight - SCROLL_OFFSET_EXTRA;

    window.scrollTo({top, behavior: "smooth"});
  };


  useEffect(() => {
    let ticking = false;

    const updateActiveSection = () => {
      const offsets = Object.entries(sections)
        .filter(([, ref]) => ref.current)
        .map(([key, ref]) => ({
          key,
          top: ref.current.getBoundingClientRect().top,
        }));

      if (offsets.length === 0) return;

      const visible = offsets.reduce((prev, curr) =>
        Math.abs(curr.top) < Math.abs(prev.top) ? curr : prev
      );

      setActiveSection(visible.key);
    };

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        updateActiveSection();
        ticking = false;
      });
    };

    updateActiveSection();
    window.addEventListener("scroll", handleScroll, {passive: true});
    return () => window.removeEventListener("scroll", handleScroll);
  }, [sections]);


  return (
    <>
      <Header onNavClick={scrollTo} activeSection={activeSection}/>
      <BackToTopButton/>

      <section ref={sections.home}><Hero/></section>
      <section ref={sections.about}><About/></section>
      <section ref={sections.products}><ProductsSection/></section>
      <section ref={sections.coverage}><Coverage/></section>
      <section ref={sections.team}><TeamSection/></section>
      <section ref={sections.conferences}><ConferencesSection/></section>
      <section ref={sections.contact}><ContactSection/></section>
      <Footer/>
    </>
  );
}

export default App;
